export enum ResultOrderTypes {
  RECOMMENDED = 'Consigliati',
  DATE = 'Data (cresc.)',
  PRICE = 'Prezzo (cresc.)'
}
